import axios from "axios";

export function getOrders(page = 1, limit) {
    return axios.get(`order/orders?page=${page}&limit=${limit}`);
}

export function getStatuses() {
    return axios.get(`order/status`);
}

export function getFactors() {
    return axios.get(`factor/factors/pending`);
}

export function updateFactor(data) {
    return axios.post(`factor/add/order`, data);
}

export function updateStatus(data) {
    return axios.post(`order/status/update`, data);
}